import { IRouterUtilConfiguration } from './router-util.interface';
import { configuration } from './build-specifics';

export class RouterUtil {
  static Configuration: IRouterUtilConfiguration = {
    Games: 'games',
    Tournaments: 'tournaments',
    TournamentsV2: 'tournaments-v2',
    CashTournaments: 'cash',
    PrizeTournaments: 'prizes',
    Profile: 'profile',
    ProfileOverview: 'overview',
    ProfileSecurity: 'security',
    ProfileSettings: 'personal-info',
    ProfileBusiness: 'business-info',
    ProfileSettingsWinner: 'winner',
    ProfileReferrals: 'referrals',
    ProfileSubscriptions: 'subscriptions',
    ProfilePreferences: 'preferences',
    ProfileTaxForm: 'tax-form',
    ProfileIdentity: 'identity-verification',
    ProfilePrizes: 'prizes',
    GameHistory: 'gamehistory/view',
    GameHistoryView: 'view',
    GameHistoryDetails: 'historydetails',
    Wallet: 'wallet',
    WalletDisabled: 'walletDisabled',
    WalletDeposit: 'deposit',
    WalletWithdraw: 'withdraw',
    WalletCompleteWithdraw: 'withdraw/complete',
    WalletHistory: 'history',
    ProfilePromoCodes: 'promo-codes',
    // Override configuration for specific build
    ...configuration,
  };

  static getToRedirect(): string | undefined {
    const params = new URLSearchParams(window.location.search);
    return params.get('redirectTo') || '';
  }
  static navigate(path: string) {
    const redirectTo =
      localStorage.getItem('redirectTo') || this.getToRedirect();
    const config =
      redirectTo !== '' ? { queryParams: { redirectTo } } : { queryParams: {} };

    return redirectTo
      ? {
          path: [path],
          config: {
            queryParams: { redirectTo },
          },
        }
      : { path: [path], config: {} };
  }
}
